module.exports = "/static/images/topograph-moss.webp";